export const styles = theme => ({
    radioGroup: {
        marginTop: "1rem"
    },
    paper: {
        padding: "1rem",
        width: "90%",
    },
    card: {
        height: "450px",
        position: "relative" as const,
        "& h2": {
            fontSize: 18,
            fontWeight: "bold",
        }
    },
    buttonCheckout: {
        position: "absolute" as const,
        width: "100%",
        bottom: 0,
        left: 0,
    },
    titleName: {
        fontSize: 16
    },
    price: {
        fontSize: 20
    },
    sectionInput: {
        margin: "25px 0 0 0",
        "& span": {
            fontWeight: "bold",
            display: "block"
        }
    },
    alignRight: {
        marginLeft: "auto"
    },
    selectAllButton: {
        color: "#009",
        cursor: "pointer"
    },
    marginTop: {
        marginTop: 0,
    },
    kaikoCard: {
        height: "700px",
        position: "relative" as const,
        "& h2": {
            fontSize: 18,
            fontWeight: "bold",
        }
    },
    pricingDetailsSection: {
        marginBottom: 10
    },
    smallMarginTop: {
        paddingTop: 15
    }
});
